import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getCreditNotesListService = (params = {}) => {
  return api.get(url.GET_ALL_CREDIT_NOTES, params);
};

export const addCreditNoteService = (requestParams = {}) => {
  return api.create(url.POST_CREDIT_NOTE, requestParams, false, {}, true);
};

export const editCreditNoteService = (id, queryParams) => {
  return api.put(url.PUT_CREDIT_NOTE(id), queryParams, {}, false, true);
};
export const getCreditNoteByIdService = (id) => {
  return api.get(url.GET_CREDIT_NOTE_BY_ID(id));
};

export const deleteCreditNoteService = (id) => {
  return api.delete(url.DELETE_CREDIT_NOTE(id));
};

export const getCreditNotePDFService = (id) => {
  return api.get(
    url.DOWNLOAD_CREDIT_NOTE_PDF(id),
    {},
    {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/pdf",
      },
    },
  );
};
